export default __webpack_public_path__ + "static/media/myProject.b4597d5f.png";